 
import { configureRefreshFetch } from 'refresh-fetch'

import { fetchRefreshToken } from '@/entities/Authentication/AuthenticationService'
import { isFetchResultSuccessful } from '@/entities/FetchResult'

import { version } from '../../package.json'
import { apiRefreshTokenStorage, apiTokenStorage, tenantStorage } from './authStorage'

interface RequestInitExtraOptions extends RequestInit {
    disableContentType?: boolean
}

const fetchWithToken = async (url: string, options?: RequestInitExtraOptions): Promise<Response> => {
    const optionsWithToken: RequestInit = {
        ...options,
        headers: {
            Accept: 'application/vnd.api+json',
            ...(! options?.disableContentType && { 'Content-Type': 'application/vnd.api+json' }),
            ...options?.headers,
        },
    }

    const apiToken = apiTokenStorage.get()
    const tenant = tenantStorage.get() || process.env.REACT_APP_TENANT || window.location.hostname

    if (apiToken) {
        optionsWithToken.headers = {
            ...optionsWithToken.headers,
            Authorization: `Bearer ${apiToken}`,
            Tenant: tenant,
            App: 'employee',
            'App-Version': version,
        }
    }

    const response = await fetch(url, optionsWithToken)

    if (response.status === 401) {
        return Promise.reject({
            response,
        })
    }

    return response
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const shouldRefreshToken = (error: any): boolean => error?.response?.status === 401

const updateRefreshToken = async (): Promise<void> => {
    const apiRefreshToken = apiRefreshTokenStorage.get()

    if (! apiRefreshToken) {
        throw new Error('No token found')
    }

    const refreshResponse = await fetchRefreshToken(apiRefreshToken)

    if (! isFetchResultSuccessful(refreshResponse)) {
        apiRefreshTokenStorage.remove()
        apiTokenStorage.remove()
        window.location.href = '/'

        throw new Error('Refresh token was invalid')
    }

    apiTokenStorage.set(refreshResponse.data.token)
    apiRefreshTokenStorage.set(refreshResponse.data.refresh_token)
}

export const authorizedFetch = configureRefreshFetch({
    fetch: fetchWithToken,
    refreshToken: updateRefreshToken,
    shouldRefreshToken,
})
 
